module.exports = __FOREMAN_VENDOR__REACT_DIFF_VIEW__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_DIFF_VIEW__"
// module id = react-diff-view
// module chunks = 32